import styled from '@emotion/styled';
import Theme from 'App.theme';

interface CrumbActive {
  complete?: boolean;
}

export const Container = styled.div`
  margin: 0 auto 4rem auto;
  width: 80%;
  display: flex;
  justify-content: center;
`;

export const CrumbNumber = styled.div`
  height: 2rem;
  width: 2rem;
  border-radius: 2rem;
  margin-bottom: 0.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const CrumbText = styled.div`
  position: absolute;
  bottom: -1rem;
  width: 20rem;
  text-align: center;
`;

export const CrumbLine = styled.span<CrumbActive>`
  flex: 1;
  height: 45%;
  border-bottom: 2px solid ${({ complete }) => (complete ? Theme.colours.complete : Theme.greys.GREY2)};
`;

export const CrumbContainer = styled.div<CrumbActive>`
  display: flex;
  align-items: center;
  flex-direction: column;
  position: relative;
  margin: 0 1rem;

  .crumb-number {
    border: 2px solid ${({ complete }) => (complete ? Theme.colours.complete : Theme.greys.GREY2)};
    background-color: ${({ complete }) => (complete ? Theme.colours.complete : 'unset')};
  }

  .crumb-text {
    color: ${({ complete }) => (complete ? Theme.colours.complete : Theme.greys.GREY3)};
  }
`;
